import { Body, Footer, Header, Modal } from "../../../Modal";
import Select from "react-select";
import "./CreateLoanProductModal.css";

const amortizationMethods = [
  { value: 'fixed_interest', label: 'Fixed Interest' },
  { value: 'reducing_balance', label: 'Reducing Balance' },
  { value: 'straight_line', label: 'Straight Line' }
];

const interestFrequencies = [
  { value: 'annually', label: 'Annually' },
  { value: 'monthly', label: 'Monthly' }
];

const durationUnits = [
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' }
];

export default function CreateLoanProductModal(
  {
    showProductModal,
    handleCloseModal,
    selectedProduct,
    loanProductData,
    setLoanProductData,
    validationErrors,
    isSubmitting,
    handleSubmit,
  }
) {
  return (
    <Modal show={showProductModal} size="md">
      <Header>
        <h5 className="modal-title">{selectedProduct ? "Edit Product" : "Create Product"}</h5>
        <button
          type="button"
          className="close"
          onClick={handleCloseModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Header>
      <Body>
        <div className="form-group">
          <label>Product Code <span className="required">*</span></label>
          <input
            type="text"
            className="form-control"
            value={loanProductData.code}
            onChange={(e) => setLoanProductData(prev => ({ ...prev, code: e.target.value }))}
            placeholder="Enter product code e.g 'PL'"
          />
          <span className="text-danger">{validationErrors.code}</span>
        </div>

        <div className="form-group">
          <label>Product Name <span className="required">*</span></label>
          <input
            type="text"
            className="form-control"
            value={loanProductData.name}
            onChange={(e) => setLoanProductData(prev => ({ ...prev, name: e.target.value }))}
            placeholder="Enter product name e.g 'Personal Loan'"
          />
          <span className="text-danger">{validationErrors.name}</span>
        </div>

        <div className="form-group">
          <label><i className="fa fa-calculator"></i> Amortization Method <span className="required">*</span></label>
          <Select
            name="amortization_method"
            options={amortizationMethods}
            value={amortizationMethods.find(method => method.value === loanProductData.amortization_method)}
            onChange={(e) => setLoanProductData(prev => ({ ...prev, amortization_method: e.value }))}
            className="form-control-select"
            placeholder="Select Amortization Method e.g 'Reducing Balance'"
            isClearable={false}
          />
          <span className="text-danger">{validationErrors.amortization_method}</span>
        </div>
        <div className="form-group">
          <label>Interest Rate <span className="required">*</span></label>
          <div className="input-group-container">
            <input
              type="number"
              className="form-control"
              value={loanProductData.interest_rate}
              onChange={(e) => setLoanProductData(prev => ({ ...prev, interest_rate: e.target.value }))}
              placeholder="Enter interest rate e.g '10'"
            />
            <Select
              name="interest_frequency"
              options={interestFrequencies}
              value={interestFrequencies.find(frequency => frequency.value === loanProductData.interest_frequency)}
              onChange={(e) => setLoanProductData(prev => ({ ...prev, interest_frequency: e.value }))}
              className="form-control-select"
              placeholder="Select Interest Frequency e.g 'Monthly'"
            />
          </div>
          <span className="text-danger">{validationErrors.interest_rate || validationErrors.interest_frequency}</span>
        </div>
        <div className="form-group">
          <label>Duration <span className="required">*</span></label>
          <div className="input-group-container">
            <input
              type="number"
              className="form-control"
              value={loanProductData.duration}
              onChange={(e) => setLoanProductData(prev => ({ ...prev, duration: e.target.value }))}
              placeholder="Enter duration e.g '12'"
            />
            <Select
              name="duration_unit"
              options={durationUnits}
              value={durationUnits.find(unit => unit.value === loanProductData.duration_unit)}
              onChange={(e) => setLoanProductData(prev => ({ ...prev, duration_unit: e.value }))}
              className="form-control-select"
              placeholder="Select Duration Unit e.g 'Months'"
            />
          </div>
          <span className="text-danger">{validationErrors.duration || validationErrors.duration_unit}</span>
        </div>
        
        <div className="form-group">
          <label>Description <span className="required">*</span></label>
          <textarea
            className="form-control"
            value={loanProductData.description}
            onChange={(e) => setLoanProductData(prev => ({ ...prev, description: e.target.value }))}
            placeholder="Enter product description e.g 'This is a personal loan'"
            rows="3"
          />
          <span className="text-danger">{validationErrors.description}</span>
        </div>
      </Body>
      <Footer>
        <button
          type="button"
          className="btn btn-cancel"
          onClick={handleCloseModal}
        >
          <i className="fa fa-times mr-1"></i> Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary ml-2"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <i className="fa fa-spinner fa-spin"></i>
          ) : (
            <><i className="fa fa-save mr-1"></i> Save</>
          )}
        </button>
      </Footer>
    </Modal>
  );
}
